// src/hooks/useLogin.js
import {useMutation} from '@tanstack/react-query';
import {login, register} from "../api/userInstance";
import {replace, useNavigate} from "react-router";


export const useRegister = () => {
    const navigate = useNavigate();
    const {mutate: loginUser} = useLogin()

    return useMutation({
        mutationFn: register,
        onSuccess: (_data, variables) => {
            loginUser(variables);
        },
    });
};

export const useLogin = () => {
    const navigate = useNavigate();

    return useMutation({
        mutationFn: login,
        onSuccess: () => {
            navigate('/');
            // Remplacez '/dashboard' par le chemin désiré
        },
    });
}
